<template>
  <div class="ag-cell-link-renderer__link" data-test-id="grid-list__link-renderer">
    <span :class="{ 'ag-cell-link-renderer__wrapped-column': isColumnWrapped }">
      <span v-for="(link, index) in params.value" :key="link.url" ref="links">
        <a v-if="link.url" :href="link.url" target="_blank" v-on="params.trackingEvent ? { click: track } : {}">
          {{ link.text }}</a
        ><span v-else>{{ link.text }}</span
        ><span v-if="params.value.length > 1 && index < params.value.length - 1">,</span>
      </span>
      <span class="ag-cell-link-renderer__empty-value" v-if="params.value.length === 0 && params.valueWhenEmpty">{{
        params.valueWhenEmpty
      }}</span>
    </span>

    <transition name="fade-transition">
      <span v-if="!isColumnWrapped && params.value.length" class="ag-cell__gradient"></span>
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { TrackingEventType } from '@/tracking/trackingTypes';
import { GridPaper } from '@components/Scholar/types';
import { ICellRendererParams } from 'ag-grid-community';
import { GridableEntity } from '../utils/types';

export default defineComponent({
  name: 'LinkRenderer',

  props: {
    params: {
      type: Object as PropType<
        ICellRendererParams<GridableEntity | GridPaper, Array<{ text: string; url: string | null }>> & {
          valueWhenEmpty?: string;
          trackingEvent?: TrackingEventType;
        }
      >,
      required: true,
    },
  },

  data(): {
    isColumnWrapped: boolean;
    colId: string;
  } {
    return {
      isColumnWrapped: true,
      colId: '',
    };
  },

  methods: {
    track(event: MouseEvent) {
      this.$tracker.track(this.params.trackingEvent, {
        url: (event.target as HTMLAnchorElement).getAttribute('href'),
      });
    },
  },

  created() {
    this.colId = this.params.column.getColId();
    this.$watch(
      () => this.$store.state.gridWrap.wrappedColumns[this.colId],
      () => {
        this.isColumnWrapped = this.$store.getters['gridWrap/isColumnWrapped'](this.colId);
      },
      { immediate: true }
    );
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'mixins/typography';
@use 'mixins/cell-gradient';
@use 'mixins/base-renderer';

@include cell-gradient.cell-gradient;

.ag-cell-link-renderer__link {
  @include base-renderer.base-renderer;
  padding-top: 16px;
  padding-bottom: 16px;
  position: relative;
  overflow: hidden;
  @include typography.typography-14-normal(24px);
  user-select: text;

  a {
    color: colors.$color-grey-900;

    &:hover {
      text-decoration: underline;
      color: colors.$color-grey-600;
    }
  }
}

.ag-cell-wrap-text .ag-cell-link-renderer__link {
  word-break: break-word;
}

.ag-cell-link-renderer__wrapped-column {
  white-space: normal;
}

.ag-cell-link-renderer__empty-value {
  color: colors.$color-grey-400;
}
</style>
